import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    paddingTop: '2cm',
    paddingLeft: '2cm',
    paddingRight: '2cm',
    paddingBottom: '2cm',
  },
  header: {
    flexDirection: 'row',
    width: '100%',
    marginBottom: 10,
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 2,
    borderBottom: 1,
    borderStyle: 'solid',
    borderColor: '#CBD5E1',
  },
  logoContainer: {
    width: '20%',
    paddingRight: 8,
  },
  infoCenter: {
    flex: 1,
    height: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingTop: 5,
    gap: 10,
  },
  name: {
    fontSize: 14,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#003366',
  },
  title: { fontSize: 14, marginBottom: 5 },
  metaData: {
    fontSize: 10,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    borderLeft: 1,
    borderStyle: 'solid',
    borderColor: '#CBD5E1',
    paddingLeft: 8,
    height: '70%',
  },
  sectionTitle: {
    fontSize: 11,
    backgroundColor: '#eee',
    padding: 5,
    marginTop: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },

  table: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  answerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#003366',
    minHeight: 25,
    paddingHorizontal: 5,
  },
  th: {
    color: '#ffffff',
    fontSize: 10,
    fontWeight: 'bold',
    padding: 5,
  },
  td: {
    color: '#2d3748',
    fontSize: 10,
    padding: 5,
    flex: 1,
  },
  rowWhite: { backgroundColor: '#ffffff' },
  rowGray: { backgroundColor: '#cbd5e0' },

  answerVerticalRow: {
    flexDirection: 'column',
    width: '100%',
    marginBottom: 10,
  },

  valueObservacao: {
    fontSize: 11,
    padding: 6,
    paddingLeft: 12,
    fontFamily: 'Helvetica-Oblique',
  },
  labelPergunta: {
    fontSize: 11,
    color: '#000000',
    padding: 6,
    fontWeight: 'bold',
  },
  valueResposta: {
    fontSize: 11,
    color: '#000000',
    padding: 6,
    paddingLeft: 12,
    marginBottom: 3,
  },

  formGroup: { marginBottom: 20 },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    borderWidth: 1,
    borderColor: '#ccc',
    padding: 5,
  },
  gridItem: { width: '50%', marginBottom: 8 },
  label: { fontSize: 9, color: '#666', marginBottom: 2 },
  value: { fontSize: 11, fontWeight: 'bold' },
  footer: {
    position: 'absolute',
    bottom: 30,
    right: 30,
    fontSize: 9,
    color: '#666',
    fontFamily: 'Helvetica',
  },
  labelBold: {
    fontFamily: 'Helvetica-Bold',
  },
  answerScope: {
    marginBottom: 10,
  },
});
